module.exports = __webpack_public_path__ + "img/hvad-har-du-lavet-2.f32be18d.png";